import { Injectable } from '@angular/core';
import { WindowRef } from '@sb-tools/typescript/services/window-ref.service';

// TODO: move to quill service?
@Injectable({
    providedIn: 'root',
})
export class ToolbarHelperService {
    isShowFormatting = true;

    constructor(private windowRef: WindowRef) {
        this.isShowFormatting =
            this.windowRef.nativeWindow.localStorage.getItem('isShowFormatting') === 'false' ? false : true;
    }

    toggleFormatting() {
        this.isShowFormatting = !this.isShowFormatting;
        this.windowRef.nativeWindow.localStorage.setItem('isShowFormatting', this.isShowFormatting.toString());
    }
}
